import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Response = Api.Core.DealerGroup.DeleteProductEnhancementDocument.IResponse;
type Headers = Api.Core.DealerGroup.DeleteProductEnhancementDocument.IHeaders;
const apiDealerGroupDeleteProductDocumentPath =
  '/api/DealerManagement/DealerGroup/DeleteProductEnhancementDealerGroupDocument/:productEnhancementDealerGroupDocumentId';
export default async function dealerGroupDeleteProductEnhancementDocumentApi(params: {
  productEnhancementDealerGroupDocumentId: number;
}): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(apiDealerGroupDeleteProductDocumentPath, {
      productEnhancementDealerGroupDocumentId: params.productEnhancementDealerGroupDocumentId,
    }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
